module.exports = __webpack_public_path__ + "img/chatbot_cn.6e308555.png";